import jQuery from "jquery";
import { BRAND_ICON_KEY, EVENT, FILTERS_LOOKUP, categories } from "../data/constants";
import { SETTINGS } from "../settings";
import templates from "../templates";
import { EventManager } from "../utils/global";
import { FilterSystem } from "../utils/ui";
import SERVICE_REGISTRY from "./registry";

const $ = jQuery;
const blankIcon =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wIAAgMBApncSwAAAABJRU5ErkJggg==";
function closeContainerFilter(container) {
    container.find(".storemap-filtertitle-extendbutton").addClass("up-button").removeClass("down-button");
    container.find(".storemap-filterdetail-container").hide();
}
function openContainerFilter(container) {
    container.find(".storemap-filtertitle-extendbutton").addClass("down-button").removeClass("up-button");
    container.find(".storemap-filterdetail-container").show();
}

export class FilterService {
    constructor() {
        // Query dictionnary containing which filter is currently select
        this.currentQueryTags = {};
        this.initialQueryTypes = [];

        this.template = null;
        this.callback = null;
    }
    renderFavorites() {
        const translationSources = {
            [categories.CAR_WASH]: total.maps.L10n.sub_categories,
            MOP: total.maps.L10n.means_of_payments,
            OFFERS: total.maps.L10n.offers,
            BRANDS: total.maps.L10n.brand,
            DEFAULT: total.maps.L10n.products,
        };
        const favButtons = [];
        const favorites = this.favorites.map((key) => {
            const category = this.getCategoryFromSelectedValue(key);
            const translations = translationSources[category] || translationSources.DEFAULT;
            const name = category === "BRANDS" ? translations[key] : translations[key]?.name;
            return {
                key,
                name: name || "",
            };
        });
        if (favorites && favorites.length > 0) {
            favorites.forEach((filter, index) => {
                const button = document.createElement("button");
                button.className = "wm-btn--pill";
                button.setAttribute("data-id", "filter-pill");
                button.setAttribute("data-fav-id", filter.key);
                button.setAttribute("data-filter-active", "0");
                button.setAttribute("tabindex", (9 + index).toString());
                button.textContent = filter.name;
                favButtons.push(button);
            });
        }
        return favButtons;
    }
    _generateTemplate() {
        const template = $("<div>");
        let closeContainer = this.filters.length > 0;
        let panelOpened = false;
        const brandTranslations = total.maps.L10n.brand;
        const productsTranslations = total.maps.L10n.products;
        const paymentsTranslations = total.maps.L10n.means_of_payments;
        const offersTranslations = total.maps.L10n.offers;
        const subcategoryTranslations = total.maps.L10n.sub_categories;
        let addtionalFilters = [];
        const matchedCategoryCodes = new Set();
        let brandsFragment = null;

        //APPEND FILTER BANDS BY FREEZED ORDER
        for (const parentFilter of FILTERS_LOOKUP) {
            let filters = [];
            if (parentFilter.type === "CATEGORIES") {
                // CATEGORIES-WITH PRODUCTS
                const title = total.maps.L10n.categories[parentFilter.code];
                const category = this.categories.find(
                    (cat) => cat.code.toLowerCase() === parentFilter.code.toLowerCase(),
                );
                if (category) {
                    matchedCategoryCodes.add(category.code.toUpperCase());
                    if (parentFilter.code === categories.CAR_WASH) {
                        filters = category.subcategories.filter((subcategory) => subcategory !== "CARWASH_CARD");
                    } else {
                        filters = category.products;
                    }
                    if (parentFilter.code === "ENERGIES") {
                        filters = this.sortProductsByKey(filters, "name");
                    } else {
                        filters = filters.sort();
                    }

                    const container = $(
                        templates.common.searchFilterContainer.render({
                            title,
                            reset: total.maps.L10n.ui.search.reset,
                        }),
                    );
                    // On load, only open the first filter container
                    // Have to do it this way because previous used index in forEach but returned early if no filters
                    // messing with the opening of the first container
                    const list = container.find(".wm-modal--filters-list-item-sublist");
                    if (closeContainer) {
                        closeContainerFilter(container);
                    } else {
                        // container.addClass("wm-open");
                        // list.addClass("wm-open");
                        closeContainer = true;
                    }

                    let checked = true;
                    let containerActive = false;
                    let icon;
                    for (const filter of filters) {
                        checked = this.filters.indexOf(filter) !== -1;
                        containerActive = containerActive || checked;
                        if (checked && !panelOpened) {
                            openContainerFilter(container);
                            panelOpened = true;
                        }

                        list.append(
                            templates.common.searchFilter.render({
                                id: filter,
                                checked,
                                active: checked ? "1" : "0",
                                category: category.code,
                                classname: checked ? "wm-btn--filter wm-active" : "wm-btn--filter",
                                name:
                                    category.code === categories.CAR_WASH
                                        ? subcategoryTranslations[filter].name
                                        : productsTranslations[filter].name,
                                iconUrl:
                                    category.code === categories.CAR_WASH
                                        ? subcategoryTranslations[filter].pictogram_url || blankIcon
                                        : productsTranslations[filter].pictogram_url || blankIcon,
                            }),
                        );
                        if (checked) {
                        }
                    }
                    if (filters.length % 2 !== 0) {
                        // list.append('<li class="storemap-filteritem-container"></li>');
                    }
                    // if (containerActive) {
                    //     container.addClass("wm-open");
                    //     list.addClass("wm-open");
                    // }
                    template.append(container);
                }
            } else if (parentFilter.type === "OFFERS") {
                // OFFERS/MARKETING EVENTS
                if (total.maps.parameters.offers?.length > 0) {
                    const offersContainer = $(
                        templates.common.searchFilterContainer.render({
                            title: total.maps.L10n.ui.search.offers,
                            reset: total.maps.L10n.ui.search.reset,
                        }),
                    );
                    if (closeContainer) {
                        closeContainerFilter(offersContainer);
                    } else {
                        closeContainer = true;
                    }
                    addtionalFilters = [];
                    addtionalFilters = total.maps.parameters.offers;
                    addtionalFilters = addtionalFilters.sort();
                    const offersList = offersContainer.find(".wm-modal--filters-list-item-sublist");
                    let offersChecked = false;
                    let offersContainerActive = false;
                    for (const filter of addtionalFilters) {
                        offersChecked = this.filters.indexOf(filter) !== -1;
                        if (offersChecked && !panelOpened) {
                            openContainerFilter(offersContainer);
                            panelOpened = true;
                        }
                        offersContainerActive = offersContainerActive || offersChecked;
                        offersList.append(
                            templates.common.searchFilter.render({
                                id: filter,
                                checked: offersChecked,
                                category: "OFFERS",
                                name: offersTranslations[filter].name,
                                iconUrl: offersTranslations[filter].pictogram_url || blankIcon,
                                classname: offersChecked ? "wm-btn--filter wm-active" : "wm-btn--filter",
                            }),
                        );
                    }
                    // if (offersContainerActive) {
                    //     offersContainer.addClass("wm-open");
                    //     offersList.addClass("wm-open");
                    // }
                    template.append(offersContainer);
                }
            } else if (parentFilter.type === "MOP") {
                //MEANS_OF_PAYMENT
                if (total.maps.parameters.means_of_payments?.length > 0) {
                    const mopContainer = $(
                        templates.common.searchFilterContainer.render({
                            title: total.maps.L10n.ui.search.means_of_payment,
                            reset: total.maps.L10n.ui.search.reset,
                        }),
                    );
                    if (closeContainer) {
                        closeContainerFilter(mopContainer);
                    } else {
                        closeContainer = true;
                    }
                    let addtionalFilters = [];
                    addtionalFilters = total.maps.parameters.means_of_payments;
                    addtionalFilters = addtionalFilters.sort();
                    const mopList = mopContainer.find(".wm-modal--filters-list-item-sublist");
                    let mopChecked = false;
                    let mopContainerActive = false;
                    for (const filter of addtionalFilters) {
                        mopChecked = this.filters.indexOf(filter) !== -1;
                        if (mopChecked && !panelOpened) {
                            openContainerFilter(mopContainer);
                            panelOpened = true;
                        }
                        mopContainerActive = mopContainerActive || mopChecked;
                        mopList.append(
                            templates.common.searchFilter.render({
                                id: filter,
                                checked: mopChecked,
                                category: "MOP",
                                name: paymentsTranslations[filter].name,
                                iconUrl: paymentsTranslations[filter].pictogram_url || blankIcon,
                                classname: mopChecked ? "wm-btn--filter wm-active" : "wm-btn--filter",
                            }),
                        );
                    }
                    // if (mopContainerActive) {
                    //     mopContainer.addClass("wm-open");
                    //     mopList.addClass("wm-open");
                    // }
                    template.append(mopContainer);
                }
            } else if (parentFilter.type === "BRANDS") {
                // BRANDS
                const brandContainer = $(
                    templates.common.searchFilterContainer.render({
                        title: SETTINGS.specificTranslation ? "Sources d'énergie" : total.maps.L10n.ui.search.brands,
                        reset: total.maps.L10n.ui.search.reset,
                    }),
                );
                if (closeContainer) {
                    closeContainerFilter(brandContainer);
                } else {
                    closeContainer = true;
                }
                addtionalFilters = [];
                addtionalFilters = this.brands;
                const list = brandContainer.find(".wm-modal--filters-list-item-sublist");
                let brandChecked = false;
                let brandContainerActive = false;
                for (const filter of addtionalFilters) {
                    brandChecked = this.filters.indexOf(filter) !== -1;
                    if (brandChecked && !panelOpened) {
                        openContainerFilter(brandContainer);
                        panelOpened = true;
                    }
                    brandContainerActive = brandContainerActive || brandChecked;

                    list.append(
                        templates.common.searchFilter.render({
                            id: filter,
                            checked: brandChecked,
                            category: "BRANDS",
                            name: brandTranslations[filter],
                            active: brandChecked ? "1" : "0",
                            classname: brandChecked ? "wm-btn--filter wm-active" : "wm-btn--filter",
                            iconUrl:
                                SETTINGS.iconUrls.brand[filter]?.icon?.[BRAND_ICON_KEY[filter] ?? "default"] ??
                                SETTINGS.defaultBrandIcon,
                        }),
                    );
                }
                // if (brandContainerActive) {
                //     brandContainer.addClass("wm-open");
                //     list.addClass("wm-open");
                // }
                brandsFragment = brandContainer;
            }
        }

        // Append categories from backend config not covered by FILTERS_LOOKUP
        for (const category of this.categories) {
            if (matchedCategoryCodes.has(category.code.toUpperCase())) continue;

            const title = total.maps.L10n.categories[category.code] || category.code;
            const filters = (category.products ?? []).sort();

            const container = $(
                templates.common.searchFilterContainer.render({
                    title,
                    reset: total.maps.L10n.ui.search.reset,
                }),
            );
            const list = container.find(".wm-modal--filters-list-item-sublist");
            if (closeContainer) {
                closeContainerFilter(container);
            } else {
                closeContainer = true;
            }

            let checked = true;
            let containerActive = false;
            for (const filter of filters) {
                checked = this.filters.indexOf(filter) !== -1;
                containerActive = containerActive || checked;
                if (checked && !panelOpened) {
                    openContainerFilter(container);
                    panelOpened = true;
                }

                list.append(
                    templates.common.searchFilter.render({
                        id: filter,
                        checked,
                        active: checked ? "1" : "0",
                        category: category.code,
                        classname: checked ? "wm-btn--filter wm-active" : "wm-btn--filter",
                        name: productsTranslations[filter]?.name ?? filter,
                        iconUrl: productsTranslations[filter]?.pictogram_url || blankIcon,
                    }),
                );
            }
            template.append(container);
        }

        // BRANDS always last
        if (brandsFragment) {
            template.append(brandsFragment);
        }
        this.template = template;
    }

    _initTemplateEvents() {
        const self = this;

        function onFilterButtonClicked(e) {
            const filterButton = e.target.closest('[data-id="filter-button"], [data-id="first-filter-button"]');
            if (filterButton) {
                const isActive = $(filterButton).attr("data-filter-active");
                const selectedTag = $(filterButton).attr("data-filter-id");
                const selectedCat = $(filterButton).attr("data-filter-category");
                if (selectedCat === "BRANDS") {
                    onBrandFilterChange(filterButton);
                    return;
                }
                if (isActive === "1") {
                    SERVICE_REGISTRY.queryService.addTagWithCategory(selectedTag, selectedCat);
                } else {
                    SERVICE_REGISTRY.queryService.removeTag(selectedTag);
                }
                self._updateQuery();
            }
        }

        function onBrandFilterChange(element) {
            self._onBrandFilterRemoved(element);
        }
        function onNonBrandClearFilters() {
            const activeFilters = document.querySelectorAll(".wm-btn--filter.wm-active");
            if (activeFilters && activeFilters.length > 0) {
                for (const activeFilter of activeFilters) {
                    const tagToRemove = activeFilter.getAttribute("data-filter-id");
                    const category = activeFilter.getAttribute("data-filter-category");
                    if (category !== "BRANDS") {
                        SERVICE_REGISTRY.queryService.removeTag(tagToRemove);
                    }
                }
                self._updateQuery();
            }
        }
        function onBrandClearFilters() {
            self.selectedFilterType = {};
            self._resetBrandFilters();

            SERVICE_REGISTRY.queryService.resetTypes(self.initialQueryTypes);
            self._updateQuery();
        }
        function onClearAllClicked(e) {
            onNonBrandClearFilters();
            FilterSystem.clearAll();
            onBrandClearFilters();
        }
        $(document).on("click", ".wm-btn--filter", (e) => {
            onFilterButtonClicked(e);
        });
        $(document).on("click", '[data-id="clear-all-button"]', (e) => {
            onClearAllClicked(e);
        });
        // Swap broken pictograms (filter modal + detail view) to the transparent fallback
        // so the layout slot stays empty instead of showing the browser's broken-image glyph.
        // `error` does not bubble on <img>, so capture phase is required.
        document.addEventListener(
            "error",
            (e) => {
                const img = e.target;
                if (
                    img instanceof HTMLImageElement &&
                    img.src !== blankIcon &&
                    (img.closest(".wm-btn--filter") || img.classList.contains("wm-poi-detail--service-img"))
                ) {
                    img.src = blankIcon;
                }
            },
            true,
        );
    }
    _triggerClickOnDefaultActiveFilters() {
        const filterButtons = this.getTemplate().find(".wm-btn--filter.wm-active");
        filterButtons.each(function () {
            const filterText = $(this).find("span").text().trim();
            FilterSystem.toggleFilter(filterText, false);
        });
    }
    _removeFromInitialQueryTypes(type) {
        this.initialQueryTypes = this.initialQueryTypes.filter((item) => item !== type);
    }
    _onBrandFilterRemoved(element) {
        const isActive = $(element).attr("data-filter-active");
        const selectedBrand = $(element).attr("data-filter-id");
        const newTypes = [];
        for (const stat of this.status) {
            for (const poiType of this.poiTypes) {
                newTypes.push(this._createWoosmapType(stat, poiType, selectedBrand));
            }
        }

        if (isActive === "1") {
            for (const type of newTypes) {
                this.selectedFilterType[type] = type;
            }
        } else {
            for (const type of newTypes) {
                delete this.selectedFilterType[type];
                //TO DO: to observe why this was called?
                // this._removeFromInitialQueryTypes(type);
            }
        }

        let allTypes = [];

        for (const type of Object.values(this.selectedFilterType)) {
            allTypes.push(type);
        }
        if (allTypes.length === 0) {
            allTypes = this.initialQueryTypes;
        }

        if (allTypes.length === 0 && this.initialQueryTypes.length === 0) {
            this._resetBrandFilters();
            allTypes = this.initialQueryTypes;
        }

        SERVICE_REGISTRY.queryService.resetTypes(allTypes);
        this._updateQuery();
    }
    _removeTagFromCurrentQueryTags(tag) {
        const matchingSpan = this.getTemplate()
            .find(".wm-btn--filter span")
            .filter(function () {
                return $(this).text().trim() === tag;
            });

        const parentButton = matchingSpan.closest(".wm-btn--filter");
        if (parentButton.length) {
            if (parentButton.attr("data-filter-category") === "BRANDS") {
                this._onBrandFilterRemoved(parentButton);
            } else {
                SERVICE_REGISTRY.queryService.removeTag(parentButton.attr("data-filter-id"));
                this._updateQuery();
            }
        }
    }

    _resetBrandFilters() {
        let type;
        this.initialQueryTypes = [];
        for (const stat of this.status) {
            for (const poiType of this.poiTypes) {
                for (const brand of this.brands) {
                    type = this._createWoosmapType(stat, poiType, brand);
                    this.initialQueryTypes.push(type);
                }
            }
        }
    }
    _applyQuery() {
        const tags = SERVICE_REGISTRY.queryService.getTagArray();
        const types = SERVICE_REGISTRY.queryService.getTypeArray();
        this.callback(tags, types);
        return tags;
    }
    _updateQuery() {
        const tags = this._applyQuery();
        EventManager.notify(EVENT.SEARCH_CLICKED, $.map(tags, (tag) => tag.value).join("xxx"));
    }

    _createWoosmapType(status, poiType, brandOrSegmentation) {
        return `${status.toString()}-${brandOrSegmentation}-${poiType}`;
    }

    closeContainers() {
        if (this.template) {
            const filterContainers = this.template.find(".storemap-filter-container");
            if (filterContainers) {
                filterContainers.each(function () {
                    closeContainerFilter($(this));
                });
            }
        }
    }

    init(country, brands, filters, status, poiTypes, allCategories, favorites) {
        this.country = country;
        this.filters = filters;
        this.status = status;
        this.poiTypes = poiTypes;
        this.brands = brands;
        /*
        this.universe = universe;
        this.countryItems = countryItems;
        this.segmentations = segmentations;
        */
        this.selectedFilterType = {};
        this.categories = allCategories;
        this.favorites = favorites;
        for (const filter of filters) {
            const category = this.getCategoryFromSelectedValue(filter);
            if (category && category !== "BRANDS") {
                SERVICE_REGISTRY.queryService.addTagWithCategory(filter, category);
            }
        }
        let type;

        for (const stat of status) {
            for (const poiType of poiTypes) {
                const brandFiltersSet =
                    filters.length > 0 && brands.filter((value) => filters.includes(value)).length > 0;
                const brandFilters = filters.length > 0 ? brands.filter((value) => filters.includes(value)) : brands;
                const effectiveBrands = brandFilters.length > 0 ? brandFilters : brands;

                for (const brand of effectiveBrands) {
                    type = this._createWoosmapType(stat, poiType, brand);
                    this.initialQueryTypes.push(type);
                    if (brandFiltersSet) {
                        this.selectedFilterType[type] = type; // if brand filters are set in map options, then only add the selected brands.
                    }
                    SERVICE_REGISTRY.queryService.addType(type);
                }
            }
        }
        this._generateTemplate();
        if (this.template) {
            this._initTemplateEvents();
        }
    }
    getTemplate() {
        return this.template;
    }

    onQueryFilterChange(callback) {
        if (this.callback) throw new Error("filter callback already registered");
        this.callback = callback;
        // Initial sync, not a user search: no SEARCH_CLICKED.
        this._applyQuery();
    }
    getCategoryFromSelectedValue(item) {
        for (const [key, category] of Object.entries(this.categories)) {
            // We have to check sub categories & products too,because certain categories like CAR_WASH have checkboxes built using sub_categories and not products.
            if (category.subcategories.includes(item) || category.products.includes(item)) {
                return category.code;
            }
        }
        // Means Of Payments to be checked diferently as they don't fall under generic categories
        if (total.maps.parameters.means_of_payments.includes(item)) {
            return "MOP";
        }
        // Offers/Mkt events to be checked diferently as they don't fall under generic categories
        if (total.maps.parameters.offers.includes(item)) {
            return "OFFERS";
        }
        if (total.maps.parameters.brand.includes(item)) {
            return "BRANDS";
        }
        return null;
    }
    sortProductsByKey(source, sortBy) {
        const productsTranslations = total.maps.L10n.products;
        const sortedArray = source
            .map((key) => ({ key, ...productsTranslations[key] }))
            .sort((a, b) => a[sortBy].localeCompare(b[sortBy]));
        const sortedKeys = sortedArray.map((item) => item.key);
        return sortedKeys;
    }
}
